import { memo, useMemo } from "react";

import { Flex } from "@chakra-ui/react";

import {
  mockDataCompaniesFilters,
  mockDataPanels,
} from "../../companiesList/companiesListComponents/tablesTools/innerComponents/filtersBlock/mocksData/mockDataPanels";
import SearchByKeywords from "../SearchByKeywords";

import FilterGroupSection from "./FilterGroupSection";
import FilterPanelTitleItem from "./FilterPanelTitleItem";

const CompanyCardFilter = ({ filters }) => {
  const sectionGroup = useMemo(() => {
    return mockDataCompaniesFilters({ filtersList: filters });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex
      direction={"column"}
      rowGap={"24px"}
      p={"20px"}
      bg={"white"}
      borderRadius={"10px"}
      boxShadow={{
        base: "none",
        lg: "0px 0px 14px 0px rgba(114, 114, 114, 0.25)",
      }}
    >
      <SearchByKeywords />
      {mockDataPanels()?.map((panel) => (
        <Flex direction={"column"} rowGap={"18px"} key={panel?.id}>
          <FilterPanelTitleItem panel={panel} />
          <FilterGroupSection sectionGroup={sectionGroup?.[panel?.id]} />
        </Flex>
      ))}
    </Flex>
  );
};

export default memo(CompanyCardFilter);
